export enum AddressMeetingKind {
  OFFICE = 'office',
  CLIENT = 'client',
  TELECONFERENCE = 'teleconference',
  OTHER = 'other'
}
